import React from 'react';
import styled from "styled-components";
import {dark_green, highlight_green} from "../colors";

const EnableFilterAtSidebar = (props) => {
    return <EnableFilterAtSidebarButton onClick={() => props.setIsSearchFormVisible(true)}
                                        aria-label={'enable filter'}>
        <FilterText>Filter</FilterText>
        <SettingsIcon>
            <path d="m 31.2152,123.812 v 13.23 c -1.4744,0.365 -2.5709,1.698 -2.5709,3.284 0,1.585 1.0965,2.919 2.5709,3.284 v 4.577 c 0,0.449 0.3638,0.813 0.8125,0.813 0.4487,0 0.8125,-0.364 0.8125,-0.813 v -4.577 c 1.4744,-0.365 2.5709,-1.699 2.5709,-3.284 0,-1.586 -1.0965,-2.92 -2.5709,-3.284 v -13.23 c 0,-0.448 -0.3638,-0.812 -0.8125,-0.812 -0.4487,0 -0.8125,0.364 -0.8125,0.812 z m 2.5709,16.514 c 0,0.969 -0.7888,1.758 -1.7584,1.758 -0.9696,0 -1.7584,-0.789 -1.7584,-1.758 0,-0.97 0.7888,-1.759 1.7584,-1.759 0.9696,0 1.7584,0.789 1.7584,1.759 z m -9.5984,-16.514 v 4.578 c -1.4744,0.365 -2.5709,1.699 -2.5709,3.284 0,1.586 1.0965,2.919 2.5709,3.284 v 13.229 c 0,0.449 0.3638,0.813 0.8125,0.813 0.4487,0 0.8125,-0.364 0.8125,-0.813 v -13.229 c 1.4743,-0.365 2.5709,-1.698 2.5709,-3.284 0,-1.585 -1.0966,-2.919 -2.5709,-3.284 v -4.578 c 0,-0.448 -0.3638,-0.812 -0.8125,-0.812 -0.4487,0 -0.8125,0.364 -0.8125,0.812 z m 2.5709,7.862 c 0,0.97 -0.7888,1.759 -1.7584,1.759 -0.9696,0 -1.7584,-0.789 -1.7584,-1.759 0,-0.969 0.7888,-1.758 1.7584,-1.758 0.9696,0 1.7584,0.789 1.7584,1.758 z m -7.9735,16.513 v -4.577 c 1.4744,-0.365 2.571,-1.699 2.571,-3.284 0,-1.586 -1.0966,-2.919 -2.571,-3.284 v -13.23 c 0,-0.448 -0.3637,-0.812 -0.8125,-0.812 -0.4487,0 -0.8125,0.364 -0.8125,0.812 v 13.23 c -1.4743,0.365 -2.5709,1.698 -2.5709,3.284 0,1.585 1.0966,2.919 2.5709,3.284 v 4.577 c 0,0.449 0.3638,0.813 0.8125,0.813 0.4487,0 0.8125,-0.364 0.8125,-0.813 z m -2.5709,-7.861 c 0,-0.97 0.7888,-1.759 1.7584,-1.759 0.9697,0 1.7585,0.789 1.7585,1.759 0,0.969 -0.7888,1.758 -1.7585,1.758 -0.9696,0 -1.7584,-0.789 -1.7584,-1.758 z" fill={dark_green}/>
        </SettingsIcon>
    </EnableFilterAtSidebarButton>
};

const EnableFilterAtSidebarButton = styled.button`
    position: fixed;
    top: calc(50% - 100px);
    right: 0;
    writing-mode: vertical-lr;
    height: 200px;
    width: 50px;
    z-index: 100000;
    color: ${dark_green};
    background-color: ${highlight_green};
    border-radius: 20px 0 0 20px;
    border: 0;
`;

const FilterText = styled.span`
    margin-bottom: 40px;
`;

const SettingsIcon = styled.svg`
    color: ${dark_green};
    position: absolute;
    top: -5px;
    left: 0;
`;

export default EnableFilterAtSidebar;
